import { setAutoCollectionEnabled } from '../actions/guidedCaptureOptionActions';
import getAutoCollectionEnabled from '../selectors/getAutoCollectionEnabled';
import { observer } from 'mobx-react';
import { OptionsCheckbox } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';

@observer
export default class GuidedCaptureFull extends React.Component<{}, {}> {
    render() {
        let isAutoCollectionEnabled = getAutoCollectionEnabled();

        return (
            <div>
                <OptionsCheckbox
                    label={strings.options_guidedCapture_autoCollectionLabel}
                    checked={isAutoCollectionEnabled}
                    onChange={this.onAutoCollectionEnabledChanged}
                />
            </div>
        );
    }

    private onAutoCollectionEnabledChanged = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        setAutoCollectionEnabled(checked);
    };
}
